module.exports = __webpack_public_path__ + "img/fig01.3de60c54.jpg";